import "./targetForm.scss";
import Banner from "../../components/banner/Banner"

import { useState } from "react";
import api from "../../services/api";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { useReducer } from "react";
const TargetForm = () => {
  const navigate = useNavigate();
  // Get targetId from URL if editing
  const targetId = parseInt(window.location.pathname.split("/")[2]) || null;
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);


const reducer = (state, action) => {
  switch (action.type) {
    case "ADD_PHONE":
      return {
        ...state,
        phones: [...state.phones, { number: "", category: "MOBILE" }],
      };
    case "REMOVE_PHONE":
      return {
        ...state,
        phones: state.phones.filter((_, i) => i !== action.index),
      };
    case "CHANGE_PHONE":
      return {
        ...state,
        phones: state.phones.map((phone, i) =>
          i === action.index
            ? { ...phone, [action.field]: action.value }
            : phone
        ),
      };
    case "ADD_EMAIL":
      return {
        ...state,
        emailAddresses: [...state.emailAddresses, { email_address: "" }],
      };
    case "REMOVE_EMAIL":
      return {
        ...state,
        emailAddresses: state.emailAddresses.filter((_, i) => i !== action.index),
      };
    case "CHANGE_EMAIL":
      return {
        ...state,
        emailAddresses: state.emailAddresses.map((email, i) =>
          i === action.index ?
            { ...email, [action.field]: action.value }
            : email
        ),
      };
    case "ADD_SOCIAL_ACCOUNT":
      return {
        ...state,
        socialAccounts: [...state.socialAccounts, { platform: "", link: "" }],
      };
    case "REMOVE_SOCIAL_ACCOUNT":
      return {
        ...state,
        socialAccounts: state.socialAccounts.filter((_, i) => i !== action.index),
      };
    case "CHANGE_SOCIAL_ACCOUNT":
      return {
        ...state,
        socialAccounts: state.socialAccounts.map((social, i) =>
          i === action.index ?
            { ...social, [action.field]: action.value }
            : social
        ),
      };
    case "ADD_ADDRESS":
      return {
        ...state,
        addresses: [...state.addresses, { street: "", city: "", state: "", zip_code: "", country: "" }],
      };
    case "REMOVE_ADDRESS":
      return {
        ...state,
        addresses: state.addresses.filter((_, i) => i !== action.index),
      };
    case "CHANGE_ADDRESS":
      return {
        ...state,
        addresses: state.addresses.map((address, i) =>
          i === action.index ?
            { ...address, [action.field]: action.value }
            : address
        ),
      };
    case "ADD_NATIONALITY":
      return {
        ...state,
        nationalities: [...state.nationalities, { country_code: "" }],
      };
    case "REMOVE_NATIONALITY":
      return {
        ...state,
        nationalities: state.nationalities.filter((_, i) => i !== action.index),
      };
      case "CHANGE_NATIONALITY":
        return {
          ...state,
          nationalities: state.nationalities.map((nationality, i) =>
            i === action.index?
          { ...nationality, [action.field]: action.value }
          : nationality
          ),
        };

      case "UPDATE_FIELD":
        return {
          ...state,
          [action.field]: action.value,
        };
      default:
        return state;
  }
};

const initialTarget = {
  name: "",
  date_of_birth: "",
  aliases: "",
  phones: [],
  addresses: [],
  socialAccounts: [],
  emailAddresses: [],
  nationalities: [],
};

const [target, dispatch] = useReducer(reducer, initialTarget);


  // Fetch existing target data if targetId is provided (editing mode)
  const { isLoading: isTargetLoading } = useQuery(
    ["target", targetId],
    () => api.get(`/api/osint/target/${targetId}/`).then((res) => res.data),
    {
      enabled: !!targetId, // Only run this query if targetId exists
      onSuccess: (data) => {
        dispatch({type: "UPDATE_FIELD", field: "name", value: data.name || ""});
        dispatch({type: "UPDATE_FIELD", field: "date_of_birth", value: data.date_of_birth || ""});
        dispatch({type: "UPDATE_FIELD", field: "aliases", value: data.aliases || ""});
        dispatch({type: "UPDATE_FIELD", field: "phones", value: data.phones || []});
        dispatch({type: "UPDATE_FIELD", field: "socialAccounts", value: data.social_accounts || []});
        dispatch({type: "UPDATE_FIELD", field: "addresses", value: data.addresses || []});
        dispatch({type: "UPDATE_FIELD", field: "emailAddresses", value: data.email_addresses || []});
        dispatch({type: "UPDATE_FIELD", field: "nationalities", value: data.nationalities || []});
      },
    }
  );

  // Handle input changes
  const handleChange = (e) => {
     dispatch({type: "UPDATE_FIELD", field: e.target.name, value: e.target.value})
  };

  
  // Mutation for creating or updating target
  const mutation = useMutation(
    (targetPayload) => {
      if (targetId) {
        // Update existing target
        return api.put(`/api/osint/target/${targetId}/`, targetPayload);
      } else {
        // Create new target
        return api.post("/api/osint/targets/create/", targetPayload);
      }
    },
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries(["target", targetId]);
        queryClient.invalidateQueries("targets");
        navigate(`/target/${res.data.id}`);
      },
      onError: (error) => {
        if (error.response && error.response.data) {
          setError(error.response.data);
        } else {
          setError("An error occurred. Please try again.");
        }
      },
    }
  );

  const handleCancel = (e) => {
    e.preventDefault();
    if (targetId) {
      navigate(`/target/${targetId}`);
    } else {
      navigate(`/targets`);
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (target.aliases === "") {
      dispatch({type: "UPDATE_FIELD", field: "aliases", value: null});
    }

    if (!target.name) {
      setError("You must provide a name for your target.");
      return;
    }

    // Ensure date_of_birth is formatted as 'YYYY-MM-DD' if provided
    const targetPayload = {
      ...target,
      date_of_birth: target.date_of_birth
        ? new Date(target.date_of_birth).toISOString().split("T")[0]
        : null,
    };
    
    console.log("targetPayload:");
    console.log(targetPayload);
    mutation.mutate(targetPayload);
  };

  if (isTargetLoading && targetId) {
    return <div>Loading...</div>;
  }

  return (<>
    <div className="targetForm">
    {targetId ? (<Banner title="Edit Target Profile" image="/images/cover_target.png"/>):(<Banner title="Create Target Profile" image="/images/cover_target.png"/>)}
      <div className="container">
        <h2>{target.name}</h2>
        <form onSubmit={handleSubmit}>
          {error && (
            <div className="error">
              {typeof error === "string"
                ? error
                : Object.entries(error).map(([key, value]) => (
                    <div key={key}>{`${key}: ${value}`}</div>
                  ))}
            </div>
          )}

          {/* Fields common to both create and edit */}
          <div className="formGroup">
            <label>Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter target name"
              value={target.name}
              onChange={handleChange}
            />
          </div>
          {/* Additional fields for editing */}
          {targetId && (
            <>
              {/* Emails */}
              <div className="section">
                <h3>Emails</h3>
                {target?.emailAddresses.map((email, index) => (
                  <div key={index} className="emailGroup">
                    <input
                      type="text"
                      placeholder="Email"
                      value={email.email_address}
                      onChange={(e) =>
                        dispatch({type: "CHANGE_EMAIL", index:index, field: "email_address", value: e.target.value})
                      }
                    />
                    <button type="button" onClick={() => dispatch({type: "REMOVE_EMAIL", index:index})}>
                      Remove
                    </button>
                  </div>
                ))}
                <button type="button" onClick={()=>dispatch({type:"ADD_EMAIL"})}>
                  Add Email
                </button>
              </div>
              <div className="formGroup">
                <label>Date of Birth:</label>
                <input
                  type="date"
                  name="date_of_birth"
                  value={target.date_of_birth}
                  onChange={handleChange}
                />
              </div>
              <div className="formGroup">
                <label>Aliases:</label>
                <input
                  type="text"
                  name="aliases"
                  placeholder="Enter aliases"
                  value={target.aliases}
                  onChange={handleChange}
                />
              </div>
              {/* Phones */}
              <div className="section">
                <h3>Phone Numbers</h3>
                {target?.phones.map((phone, index) => (
                  <div key={index} className="phoneGroup">
                    <input
                      type="text"
                      placeholder="Phone Number"
                      value={phone.number}
                      onChange={(e) =>
                        dispatch({type: "CHANGE_PHONE", index:index, field: "number", value: e.target.value})
                      }
                    />
                    <select
                      value={phone.category}
                      onChange={(e) =>
                        dispatch({type: "CHANGE_PHONE", index:index, field: "category", value: e.target.value})
                      }
                    >
                      <option value="MOBILE">Mobile</option>
                      <option value="LANDLINE">Landline</option>
                      <option value="VOIP">VoIP</option>
                      <option value="INTERNET">Internet</option>
                      <option value="OTHER">Other</option>
                    </select>
                    <button type="button" onClick={() => dispatch({type: "REMOVE_PHONE", index:index})}>
                      Remove
                    </button>
                  </div>
                ))}
                <button type="button" onClick={()=>dispatch({type: "ADD_PHONE"})}>
                  Add Phone
                </button>
              </div>
              {/* Social Accounts */}
              <div className="section">
                <h3>Social Accounts</h3>
                {target.socialAccounts.map((social, index) => (
                  <div key={index} className="socialGroup">
                    <input
                      type="text"
                      placeholder="Platform"
                      value={social.platform}
                      onChange={(e) =>
                        dispatch({type: "CHANGE_SOCIAL_ACCOUNT", index:index, field: "platform", value: e.target.value})
                      }
                    />
                    <input
                      type="text"
                      placeholder="Link"
                      value={social.link}
                      onChange={(e) =>
                        dispatch({type: "CHANGE_SOCIAL_ACCOUNT", index:index, field: "link", value: e.target.value})
                      }
                    />
                    <button type="button" onClick={() => dispatch({type: "REMOVE_SOCIAL_ACCOUNT", index:index})}>
                      Remove
                    </button>
                  </div>
                ))}
                <button type="button" onClick={()=> dispatch({type: "ADD_SOCIAL_ACCOUNT"})}>
                  Add Social Account
                </button>
              </div>
              {/* Addresses */}
              <div className="section">
                <h3>Addresses</h3>
                {target.addresses.map((address, index) => (
                  <div key={index} className="addressGroup">
                    <input
                      type="text"
                      placeholder="Street"
                      value={address.street}
                      onChange={(e) => dispatch({type: "CHANGE_ADDRESS", index:index, field: "street", value: e.target.value})}
                    />
                    <input
                      type="text"
                      placeholder="City"
                      value={address.city}
                      onChange={(e) => dispatch({type: "CHANGE_ADDRESS", index:index, field: "city", value: e.target.value})}
                    />
                    <input
                      type="text"
                      placeholder="State"
                      value={address.state}
                      onChange={(e) => dispatch({type: "CHANGE_ADDRESS", index:index, field: "state", value: e.target.value})}
                      />
                    <input
                      type="text"
                      placeholder="Zip Code"
                      value={address.zip_code}
                      onChange={(e) => dispatch({type: "CHANGE_ADDRESS", index:index, field: "zip_code", value: e.target.value})}
                    />
                    <input
                      type="text"
                      placeholder="Country"
                      value={address.country}
                      onChange={(e) => dispatch({type: "CHANGE_ADDRESS", index:index, field: "country", value: e.target.value})}
                    />
                    <button type="button" onClick={() => dispatch({type: "REMOVE_ADDRESS", index:index})}>
                      Remove
                    </button>
                  </div>
                ))}
                <button type="button" onClick={() => dispatch({type: "ADD_ADDRESS"})}>
                  Add Address
                </button>
              </div>
              {/* Nationalities */}
              <div className="section">
                <h3>Nationalities</h3>
                {target.nationalities.map((nationality, index) => (
                  <div key={index} className="nationalityGroup">
                    <input
                      type="text"
                      placeholder="Nationality"
                      value={nationality.country_code}
                      onChange={(e) =>
                        dispatch({
                          type: "CHANGE_NATIONALITY",
                          index: index,
                          field: "country_code",
                          value: e.target.value,
                        })
                      }
                    />
                    <button type="button" onClick={() => dispatch({type: "REMOVE_NATIONALITY", index: index})}>
                      Remove
                    </button>
                  </div>
                ))}
                <button type="button" onClick={()=>dispatch({type: "ADD_NATIONALITY"})}>
                  Add Nationality
                </button>
              </div>
            </>
          )}

          <div className="buttons">
            <button type="submit" disabled={mutation.isLoading}>
              {mutation.isLoading
                ? targetId
                  ? "Updating..."
                  : "Creating..."
                : targetId
                ? "Update Target"
                : "Create Target"}
            </button>
            <button type="button" onClick={handleCancel}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
    </>
  );
};

export default TargetForm;